import React, { useState } from "react";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import {
  createRazorPayOrder,
  publicPlayerCashPayment,
  razorPayOrderVerify,
} from "../../../services/publicService";
import { useParams } from "react-router-dom";

const RegistrationReview = ({
  registrationData,
  selectedPackage,
  onBack,
  onSuccess,
}) => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [paymentMode, setPaymentMode] = useState("ONLINE");
  console.log("Test Package", selectedPackage);

  // const handlePayment = async () => {
  //   try {
  //     if (!selectedPackage) {
  //       toast.error("Please select a package");
  //       return;
  //     }

  //     if (!registrationData?.id) {
  //       toast.error("Registration ID not found");
  //       return;
  //     }

  //     // ORDER API
  //     const payload = {
  //       playerId: registrationData?.id,
  //       subscriptionId: selectedPackage?.id,
  //       tenantId: id,
  //     };

  //     console.log("order payload", registrationData);
  //     const orderRes = await createRazorPayOrder(payload);

  //     if (orderRes) {
  //       const options = {
  //         key: orderRes?.keyId,
  //         amount: orderRes?.amount,
  //         currency: "INR",
  //         name: "CrickPay",
  //         description: selectedPackage?.packageType?.name,
  //         order_id: orderRes?.orderId,

  //         handler: async function (response) {
  //           try {
  //             const verifyPayload = {
  //               playerId: registrationData?.id,
  //               razorpayOrderId: response.razorpay_order_id,
  //               razorpayPaymentId: response.razorpay_payment_id,
  //               razorpaySignature: response.razorpay_signature,
  //             };

  //             const verifyRes = await razorPayOrderVerify(verifyPayload);

  //             if (verifyRes) {
  //               onSuccess({
  //                 paymentStatus: "SUCCESS",
  //               });
  //               // Swal.fire(
  //               //   "Payment Successful!",
  //               //   "Your payment has been processed successfully.",
  //               //   "success",
  //               // );
  //             } else {
  //               Swal.fire("Error!", "Payment Verification Failed", "error");
  //             }
  //           } catch (error) {
  //             Swal.fire(
  //               "Error!",
  //               error?.errorMessage || "Payment verification failed",
  //               "error",
  //             );
  //           } finally {
  //           }
  //         },

  //         prefill: {
  //           name: registrationData.name,
  //           email: registrationData.email,
  //           contact: registrationData.mobileNumber,
  //         },

  //         theme: {
  //           color: "#6673fd",
  //         },

  //         modal: {
  //           ondismiss: function () {
  //             Swal.fire("Error!", "Payment Cancelled", "error");
  //           },
  //         },
  //       };

  //       const razor = new window.Razorpay(options);

  //       razor.on("payment.failed", function () {
  //         Swal.fire("Error!", "Payment Failed", "error");
  //       });

  //       razor.open();
  //     }
  //   } catch (error) {
  //     console.error("Payment Error:", error);
  //     console.error("Response:", error?.response);
  //     console.error("Data:", error?.response?.data);

  //     Swal.fire(
  //       "Error!",
  //       error?.response?.data?.message ||
  //         error?.message ||
  //         "Payment initialization failed",
  //       "error",
  //     );
  //   }
  // };

  const handlePayment = async () => {
    if (!selectedPackage) {
      toast.error("Please select a package");
      return;
    }

    if (!registrationData?.id) {
      toast.error("Registration ID not found");
      return;
    }

    const payload = {
      playerId: registrationData.id,
      subscriptionId: selectedPackage.id,
      tenantId: id,
    };

    setLoading(true);

    try {
      if (paymentMode === "ONLINE") {
        const orderRes = await createRazorPayOrder(payload);

        if (!orderRes) {
          throw new Error("Unable to create payment order.");
        }

        const options = {
          key: orderRes.keyId,
          amount: orderRes.amount,
          currency: "INR",
          name: "CrickPay",
          description: selectedPackage?.packageType?.name,
          order_id: orderRes.orderId,

          handler: async function (response) {
            try {
              const verifyPayload = {
                playerId: registrationData.id,
                razorpayOrderId: response.razorpay_order_id,
                razorpayPaymentId: response.razorpay_payment_id,
                razorpaySignature: response.razorpay_signature,
              };

              const verifyRes = await razorPayOrderVerify(verifyPayload);

              if (verifyRes) {
                onSuccess({
                  paymentStatus: "SUCCESS",
                });
              } else {
                Swal.fire("Error!", "Payment verification failed.", "error");
              }
            } catch (error) {
              Swal.fire(
                "Error!",
                error?.response?.data?.message ||
                  error?.message ||
                  "Payment verification failed.",
                "error",
              );
            }
          },

          prefill: {
            name: registrationData.name,
            email: registrationData.email,
            contact: registrationData.mobileNumber,
          },

          theme: {
            color: "#6673fd",
          },

          modal: {
            ondismiss() {
              Swal.fire("Cancelled", "Payment cancelled.", "info");
            },
          },
        };

        const razor = new window.Razorpay(options);

        razor.on("payment.failed", () => {
          Swal.fire("Error!", "Payment failed.", "error");
        });

        razor.open();
      } else {
        const res = await publicPlayerCashPayment(payload);

        if (res) {
          onSuccess({
            paymentStatus: "SUCCESS",
          });
        }
      }
    } catch (error) {
      Swal.fire(
        "Error!",
        error?.response?.data?.message ||
          error?.message ||
          "Something went wrong.",
        "error",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="review-wrapper">
      <h3 className="review-title">Review Your Selection</h3>
      <p className="review-subtitle">Please verify your selected package</p>

      <div className="selected-title">
        <i className="fa fa-shopping-bag"></i>

        <span>Selected Package</span>
      </div>

      <div key={1} className={`package-card `}>
        <div className="package-content">
          <div className="package-info">
            <h3>{selectedPackage?.packageType?.name || "Package Name"}</h3>

            <p>{selectedPackage?.packageType?.description}</p>
            {/* <ul>
              <li>
                <i className="fa fa-check"></i>Tournament Participation
              </li>
              <li>
                <i className="fa fa-check"></i>Match Day Kit
              </li>
              <li>
                <i className="fa fa-check"></i>Certificate of Participation
              </li>
              <li>
                <i className="fa fa-check"></i>Refreshments
              </li>
            </ul> */}
          </div>

          <div className="package-price">
            <h2>₹{selectedPackage?.ammount || "0"}</h2>
          </div>
        </div>
      </div>

      {/* Selected Package */}
      {/* <div className="selected-package-box package-card ">
        <div className="selected-title">
          <i className="fa fa-shopping-bag"></i>

          <span>Selected Package</span>
        </div>

        <ul>
          <li>{selectedPackage?.packageType?.name || "Package Name"}</li>
        </ul>
      </div> */}
      <div className="payment-mode-box">
        <h5 className="payment-heading">Payment Method</h5>

        <div className="payment-options">
          <label className="payment-option">
            <input
              type="radio"
              name="paymentMode"
              value="ONLINE"
              checked={paymentMode === "ONLINE"}
              onChange={(e) => setPaymentMode(e.target.value)}
            />

            <span className="custom-radio"></span>

            <i className="fa fa-credit-card payment-icon"></i>

            <span className="payment-text">Online Payment</span>
          </label>

          <label className="payment-option">
            <input
              type="radio"
              name="paymentMode"
              value="CASH"
              checked={paymentMode === "CASH"}
              onChange={(e) => setPaymentMode(e.target.value)}
            />

            <span className="custom-radio"></span>

            <i className="fa fa-inr payment-icon"></i>

            <span className="payment-text">Cash Payment</span>
          </label>
        </div>
      </div>

      {/* Information */}
      <div className="info-box">
        <i className="fa fa-info-circle"></i>

        <span>Please verify your package before continuing to payment.</span>
      </div>

      <button
        className="continue-btn"
        onClick={handlePayment}
        disabled={loading}
      >
        {loading
          ? "Processing..."
          : paymentMode === "ONLINE"
            ? "Continue to Payment"
            : "Confirm Registration"}

        <i className="fa fa-arrow-right"></i>
      </button>

      <div className="secure-payment">
        <i className="fa fa-lock"></i>
        Secure Payment Gateway
      </div>
    </div>
  );
};

export default RegistrationReview;
